import _ from 'lodash';

export const getOverrideGroupsOutputValues = (formValues, initialFormValues) =>
  Object.entries(formValues).reduce(
    (acc, [id, isOverriden]) => {
      const isInitiallyOverriden = initialFormValues[id];
      const isOverridenChanged = isOverriden !== isInitiallyOverriden;
      const targetArray = isOverriden ? acc.itemsToOverride : acc.itemsToRemoveOverride;

      if (!isOverridenChanged) {
        return acc;
      }

      targetArray.push(id);

      return acc;
    },
    { itemsToOverride: [], itemsToRemoveOverride: [] },
  );

export const sortChecklistsTreeItems = items => _.sortBy(items, 'orderSequence');
